(function() {
    'use strict';

    var extDeps = [];
    var module = angular.module('app.common.widgets.notes',extDeps);



    module.controller('NoteDialogController', NoteDialogController);
    NoteDialogController.$inject = ['$q','$scope', '$timeout','$state', 'modalService','modalPayload','NotesApi','moment'];
    function NoteDialogController($q, $scope,$timeout, $state, modalService, modalPayload,NotesApi,moment){

        var vm = this;
        vm.dismissModal = exitState;
        vm.gotoView = gotoView;
        vm.deleteThisNote = deleteThisNote;
        vm.saveFormChanges= saveFormChanges;
        vm.tryCancelFormChanges = tryCancelFormChanges;
        vm.isReadonly = false;
        vm.note = null;
        vm.currentView = null;
        vm.loadInProgress = false;
        vm.ViewTypes = {
            LANDING_VIEW:'LANDING_VIEW'
            , EDITING_VIEW:'EDITING_VIEW'
        };



        init();

        function init(){
            askConfirmationWhenExitingForm.remove = $scope.$on('$stateChangeStart',askConfirmationWhenExitingForm);
            displayNoteAsync((modalPayload.note || {}).noteID)
                .then(function(){
                    if(!vm.note.noteID)
                        vm.gotoView(vm.ViewTypes.EDITING_VIEW);
                });
            vm.isReadonly = !!modalPayload.isReadonly;
        }

        function displayNoteAsync(noteId){
            vm.loadInProgress = true;
            vm.gotoView(vm.ViewTypes.LANDING_VIEW);

            return getNoteAsync(noteId)
                .then(function(result){
                    vm.note = result;
                })
                .finally(function(){
                    $scope.noteForm.$setPristine();
                    vm.loadInProgress = false;
                });
        }

        function exitState(){

            // reload:true called to force statechange even on default state
            $state.go('default',null,{reload:true});
        }

        function gotoView(view){
            vm.currentView = view;
            askConfirmationWhenExitingForm.remove();
            askConfirmationWhenExitingForm.remove = $scope.$on('$stateChangeStart',askConfirmationWhenExitingForm);
        }

        function deleteThisNote(){
            vm.loadInProgress = true;
            return deleteNoteAsync(vm.note.noteID)
                .then(function(){
                    vm.note = null;
                    exitState();
                })
                .finally(function(){
                    vm.loadInProgress = false;
                });
        }

        function tryCancelFormChanges(){
            if($scope.noteForm.$dirty || !vm.note.noteID)
                exitState();
            else
                displayNoteAsync(vm.note.noteID);
        }

        function saveFormChanges(){
            if (!$scope.noteForm.$dirty){
                vm.gotoView(vm.ViewTypes.LANDING_VIEW);
                return;
            }

            var isNew = !vm.note.noteID;
            vm.loadInProgress = true;
            return saveNoteAsync(vm.note)
                .then(function(result){
                    vm.note = result;
                    $scope.noteForm.$setPristine();

                    if(isNew)
                        exitState();
                    else
                        return displayNoteAsync(vm.note.noteID);
                });
        }

        // Prevents the user exiting the state with the back button (shows confirmation screen)
        function askConfirmationWhenExitingForm(event, toState, toParams, fromState){
            event.preventDefault();
            $state.go(fromState);

            var canForceClose = vm.currentView !== vm.ViewTypes.EDITING_VIEW
                || vm.currentView === vm.ViewTypes.EDITING_VIEW && !$scope.noteForm.$dirty;

            var rt = {note:vm.note };
            if(!canForceClose){
                return  modalService.notifyMessage(modalService.newCancelFormConfirmModalOptions())
                    .then(function(){
                        askConfirmationWhenExitingForm.remove();
                        if(!vm.note.noteID)
                            $scope.$close();
                        else if(vm.currentView !== vm.ViewTypes.EDITING_VIEW)
                            $scope.$close(rt);
                        else
                            displayNoteAsync(vm.note.noteID);
                    });
            }
            else
                $scope.$close(rt);

        }

        function getNoteAsync(noteId){
            if(!noteId)
                return $timeout(function(){},300)
                    .then(function(){
                        return $q.resolve({
                            noteID: undefined,
                            associatedDate: modalPayload.date ||  moment().hour(0).minute(0).second(0).millisecond(0),
                            text: undefined
                        });
                    });
            else
                return NotesApi.get({ identifier: noteId}).$promise;
        }

        function saveNoteAsync(note){
            if(note.noteID)
                return NotesApi.update(note).$promise;
            else
                return NotesApi.create(note).$promise;
        }

        function deleteNoteAsync(noteId){

            return NotesApi.delete({ identifier: noteId}).$promise;
        }
    }




})();

